export class SetPDFAttachments {
	static readonly type = '[PDFAttachments] SetPDFAttachments';
	constructor(public orderId: any) {}
}
